import React from 'react'

import BusyOverlay from 'components/common/BusyOverlay'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import theme from 'theme'

// Used in conjunction with `react-loadable` to provide a unified page loading experience
export const LoadableLoading: React.FC<{
  error?: Error
  retry: () => unknown
  pastDelay: boolean
}> = ({ error, retry, pastDelay }) => {
  if (error) {
    return (
      <div css={{ textAlign: 'center', paddingTop: theme.space[3] }}>
        <Text as="h4" css={{ marginBottom: theme.space[3] }}>
          There was an error loading this page.
        </Text>
        <Button secondary onClick={retry}>
          Retry
        </Button>
      </div>
    )
  }

  if (pastDelay) {
    return <BusyOverlay />
  }

  return null
}
